import axios from '@/plugins/axios.js'

export default () => axios